import { useEffect, useMemo, useState } from "react";
import Table from "../../components/GTable/Table";
import { GetReportsByUserIdData, GetReportsData, GetReportsExportData, GetUsersData } from "../../lib/data";
import Button from "../../components/GButton/Button";
import { categoiresColumns, reportsColumns, reportType } from "../../lib/definitions";
import Pagination from "../../ui/paginations/Paginations";
import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import i18n from "../../lib/i18n";
import ReportsFilter from "../../ui/searchFilter/reportsFilter";
import { MdOutlineFileUpload } from "react-icons/md";
import { updateReportsForm } from "../../lib/actions";

export default function Reports() {

    const location = useLocation(); 
    const [searchParams] = useSearchParams();
    const [reportsData, setReportsData] = useState([]);
    const [usersData, setUsersData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [last_page, setlast_page] = useState(1);
    const [showExportDialog, setShowExportDialog] = useState(false);
    const [isLoading, setIsLoading] = useState(true);  
    const [loadingReport, setLoadingReport] = useState(false);  

    const {userId} = useParams();

    const from_date = searchParams.get('from_date');
    const to_date = searchParams.get('to_date');
    const user_id = searchParams.get('user_id');
    const type = searchParams.get('type');

    const t = i18n.t.bind(i18n); 

    const params = useMemo(() => {
        const tempParams = [];
        if (to_date) tempParams.push({ to_date });
        if (from_date) tempParams.push({ from_date });
        if (user_id) tempParams.push({ user_id });
        if (type) tempParams.push({ type });

        return tempParams;
    }, [ type, from_date, user_id, to_date]);

    useEffect(() => {
        handleApi();
    }, [currentPage, params])

    useEffect(() => {
        handleFilter();
    }, [])

    const handleApi = async () => {
        setIsLoading(true); 
        if(location.pathname.startsWith("/users/details/")){
            const reportData = await GetReportsByUserIdData(userId, currentPage, params);
            setReportsData([]);
            setcurrentPage(reportData?.pagination?.current_page);
            setlast_page(reportData?.pagination?.last_page);
            reportData.data.map((e) => setReportsData((prev) => [...prev, e]));
        }
        else{
            const reportData = await GetReportsData(currentPage, params);
            setReportsData([]);
            setcurrentPage(reportData?.pagination?.current_page);
            setlast_page(reportData?.pagination?.last_page);
            reportData.data.map((e) => setReportsData((prev) => [...prev, e]));
        }
        setIsLoading(false);  
    };
    
    const handleFilter = async () => {
        if(location.pathname.startsWith("/users/details/")){
            const userData = await GetUsersData(currentPage, params);
            setUsersData([]);
            userData.data.map((e) => setUsersData((prev) => [...prev, e]));
        };
    };
    
    const search = async (param) => {
        if(location.pathname.startsWith("/users/details/")){
            const params = [ {"name": param} ];
            if(param){
                const userData = await GetUsersData(currentPage, params);
                setUsersData([]);
                userData.data.map((e) => setUsersData((prev) => [...prev, e]));
            };
        };
    };

    const handlePageChange = (page) => {
        setcurrentPage(page);
    };

    const openCloseExportDialog = (e) => {
        setShowExportDialog(e);
    };

    const ExportTableWithPaginiation = async (e) => {
        const exportData = await GetReportsExportData(e, params);
        setExportData([]);
        exportData.data.map((e) => setExportData((prev) => [...prev, e])); 
    };

    const confirmReport = async (e) => {
        setLoadingReport(true);
        const result = await updateReportsForm(e);
        setLoadingReport(false);
    };

    return (
        <div className="p-8 sm:p-6 md:p-8">
                <div className="">
                    <ReportsFilter search={search} usersData={usersData} reportType={reportType} values={params} />
                </div>
            {/* )} */}
            <div className="flex flex-col sm:flex-row sm:items-baseline border-t border-gray-500/100 bg-thirdly  justify-between px-5 py-5  gap-4">
                <div></div>
                <div onClick={()=>openCloseExportDialog(true)}>
                    <Button background="#302c4a" borderRadius="8px" border="border border-gray-500/80" color="white" padding="8px 24px" text={t("button.export")} icon={<MdOutlineFileUpload />} />
                </div>
           </div>
            <div>
                {isLoading ? <TableSkeleton cols={reportsColumns    }/> : (  
                    <Table name={"Reports"} showExportDialog={showExportDialog} openCloseExportDialog={openCloseExportDialog} ExportTableWithPaginiation={ExportTableWithPaginiation} rowsExportPaginiation={exportData} confirmReport={confirmReport} loadingReport={loadingReport} action={"reports"} columns={reportsColumns} rows={reportsData} />
                )}
            </div>
            <div className="flex justify-center items-center py-5">
                <Pagination currentPage={currentPage} totalPages={last_page} handleChangePage={handlePageChange} />
            </div>
        </div>
    );
};